<script>
    export default {
        props: {
            permissions: {
                required: false,
            },
            to: {
                type: Object,
                required: true,
            },
        },
        render(h) {
            // Just return default slot if user doesn't have permissions
            if(this.permissions) {
                if(Array.isArray(this.permissions)) {
                    for(permission of this.permissions) {
                        if(!$can(permission)) {
                            return this.$slots.default[0]
                        }
                    }
                } else if(!$can(this.permissions)) {
                    return this.$slots.default[0]
                }
            }

            // Return router link
            return h('router-link', {
                props: {
                    to: this.to
                }
            }, this.$slots.default)
        }
    }
</script>
